import { boot } from 'quasar/wrappers'
import activityName from '../functions/activity-name'

export default boot(({ app }) => {
	app.config.globalProperties.$activityName = activityName
})
